"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Button = _interopRequireDefault(require("@mui/material/Button"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Modal = _interopRequireDefault(require("@mui/material/Modal"));

var _Box = _interopRequireDefault(require("@mui/system/Box"));

var _react = _interopRequireDefault(require("react"));

var _Card = _interopRequireDefault(require("@mui/material/Card"));

var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));

var _CardHeader = _interopRequireDefault(require("@mui/material/CardHeader"));

var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  p: 4,
  padding: "0px"
};

var ConfirmModalComponent = function ConfirmModalComponent(props) {
  var open = props.open,
      onClose = props.onClose,
      cbConfirm = props.cbConfirm,
      title = props.title,
      subheader = props.subheader,
      confirmText = props.confirmText,
      cancelText = props.cancelText;
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    open: open,
    onClose: onClose,
    "aria-labelledby": "modal-modal-title",
    "aria-describedby": "modal-modal-description"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: style
  }, /*#__PURE__*/_react.default.createElement(_Card.default, null, /*#__PURE__*/_react.default.createElement(_CardHeader.default, {
    title: title,
    subheader: subheader
  }), /*#__PURE__*/_react.default.createElement(_CardActions.default, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    variant: "contained",
    onClick: cbConfirm
  }, confirmText !== null && confirmText !== void 0 ? confirmText : "Confirm")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    variant: "outlined",
    onClick: onClose
  }, cancelText !== null && cancelText !== void 0 ? cancelText : "Cancel")))))));
};

var _default = ConfirmModalComponent;
exports.default = _default;